<template>
  <div class="inner">
    <!-- <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
      >全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="item in itemList" :label="item.prop" :key="item.prop">{{item.label}}</el-checkbox>
    </el-checkbox-group>-->
    <el-dropdown :hide-on-click="false">
      <span class="el-dropdown-link">
        {{
          checkedCities.length === itemList.length
            ? `全部${title}`
            : `${title}${checkedCities.length}`
        }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
        >
          <el-dropdown-item v-for="item in itemList" :key="item.key">
            <el-checkbox
              :label="item.key"
              :disabled="defaultColumn.includes(item.key)"
              >{{ item.name }}</el-checkbox
            >
          </el-dropdown-item>
        </el-checkbox-group>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { transferColumnArr } from "../../utils/tool";
import { sortcheckedCities } from "../../utils/tool";

export default {
  props: {
    num: Number,
    itemList: Array,
    defaultColumn: Array,
    title: {
      type: String,
      default: "指标",
    },
    defaultCheckAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkAll: this.defaultCheckAll,
      checkedCities: transferColumnArr(this.itemList),
      isIndeterminate: false,
      defaultcheckedCities: transferColumnArr(this.itemList),
    };
  },
  methods: {
    handleCheckAllChange(val) {
      let arr = [];
      this.itemList.map((v) => arr.push(v.key));
      this.checkedCities = val ? arr : this.defaultColumn;

      this.isIndeterminate = false;
      let newColumn = [];
      this.checkedCities &&
        this.checkedCities.map((v) => {
          this.itemList.map((val) => {
            val.key == v ? newColumn.push(val) : null;
          });
        });
      if (!this.checkedCities) {
        this.checkedCities = [];
      }
      this.$emit("getColumn", newColumn);
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.itemList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.itemList.length;
      let newColumn = [];
      let sortedcheckedCities = sortcheckedCities(
        this.defaultcheckedCities,
        this.checkedCities
      );
      // this.checkedCities.map((v) => {
      //   this.itemList.map((val) => {
      //     val.prop == v ? newColumn.push(val) : null;
      //   });
      // });
      sortedcheckedCities.map((v) => {
        this.itemList.map((val) => {
          val.key == v ? newColumn.push(val) : null;
        });
      });

      this.$emit("getColumn", newColumn);
    },
  },
  watch: {
    defaultColumn: {
      handler(n, o) {
        if (n !== o) {
          this.checkedCities = n;
        }
      },
      deep: true, //对象内部属性的监听，关键。
    },
    itemList: {
      handler(n, o) {
        if (n !== o) {
          this.checkedCities = transferColumnArr(n);
        }
      },
      deep: true, //对象内部属性的监听，关键。
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.inner {
  display: inline-block;
  margin-left: 10px;
  background-color: #ebeef1;
  border: 1px solid #ebeef1;
  border-radius: 2px;
}
//下拉菜单
.el-dropdown-menu {
  height: 200px;
  overflow: auto;
}
</style>